import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper';
import GoBackButton from '@/common/components/GoBackButton';
import Table from '@/common/components/Table';
import { usePrinterMachine } from '@/common/hooks/queries/usePrinterMachine';
import { ChevronsRight } from 'lucide-react';
import { useParams } from 'react-router-dom';
import { usePrinterMachineTasks } from '../../../../common/hooks/queries/usePrinterMachineTasks';
import { Mapper } from '../../../../common/services/mapper';
import { PrinterMachineTasksData, PrinterMachineTaskTableItem } from '../../../../common/types/printerTask.type';
import { printerMachineTasksColumns } from '../../constants/printerMachineTasksColumns.constant';
import { PrinterTasksTransformer } from '../../services/printerTasksTransformer';
import DisableEnablePrinterMachine from './disableEnablePrinterMachinesTasks';

const Show = () => {
  const { id } = useParams();

  const {
    data: printerMachine,
    error: printerMachineError = {} as any,
    refetch: refetchPrinterMachine,
  } = usePrinterMachine({ id: id || '' });

  const {
    data: tasksData,
    isPending: tasksIsPending,
  } = usePrinterMachineTasks({
    filters: {
      printerMachineId: id,
    },
    mapper: Mapper.mapWithTransformer<PrinterMachineTasksData[], PrinterMachineTaskTableItem[]>({
      transformer: PrinterTasksTransformer.tableTransformer(),
    }),
  });

  return (
    <div>
      <div className="flex items-center mb-6">
        <div className="flex gap-2 items-center">
          <GoBackButton dataTestid="go_back" fallback="/printer-machines" searchLastRouteFromFallback />
          <p className="text-white-400 font-normal">Impressoras de cartão</p>
          <ChevronsRight color="#ffffffb3" />
          <h2>Ações</h2>
        </div>
      </div>

      <ErrorMessageWrapper
        className="max-h-[calc(100vh-128px)]"
        statusCode={printerMachineError?.status}
        refetchFunction={refetchPrinterMachine}
      >
        <div className="h-[calc(100vh-128px)] flex flex-col gap-3">
          <div className="flex justify-between items-center">
            <div className="flex items-center">
              <p className="text-lg font-bold" data-testid="display_name_preview">
                {printerMachine?.display_name} - <span className="text-sm text-white-400">
                  {printerMachine?.printed_cards_count} {printerMachine?.printed_cards_count! < 1 ? 'cartão impresso' : 'cartões impressos'}
                </span>
              </p>
            </div>

            {printerMachine && (
              <DisableEnablePrinterMachine printer={printerMachine} />
            )}
          </div>

          <div className="flex flex-col gap-1">
            <p>Tasks</p>

            <Table
              className="max-h-[calc(100vh-192px)]"
              columns={printerMachineTasksColumns}
              isLoadingData={tasksIsPending}
              rows={tasksData || []}
              totalPages={1}
              totalCount={tasksData?.length || 0}
              hasPagination={false}
              rowEmptyValue="--"
              page={1}
            />
          </div>
        </div>
      </ErrorMessageWrapper>

    </div >
  );
};

export default Show;